<template>
  <button class="btn-legend" :class="`btn-legend--${props.type}`"  :style="{ backgroundImage: `url('${BG}')` }">
    <div class="btn-legend__box">
      <CrownIcon/>
    </div>
    Стать Легендой Кэпитала
  </button>
</template>

<script setup>
  import { Props } from './props.js';
  //----------------------
  import CrownIcon from '@shared/UI/SVG/CrownIcon.vue';
  //----------------------
  const props = defineProps(Props());
  //----------------------
  const BG = require('@/Shared/images/backgrounds/legend_bg_long.png');
</script>

<style scoped lang="scss">
  @import "./styles.scss";
</style>
